<template>
    <div :class="{'d-none' : hidden}">
      <slot></slot>
    </div>
</template>

<script>
import eventBus from '../event-bus';

export default {
  props: {
    contentName: {
      type: String,
    }
  },
  data() {
    return {
      hidden: true
    }
  },
  mounted() {
    eventBus.$on('showContent', (eventContentName) => {
      if (eventContentName === this.contentName) {
        this.hidden = false;
      }
    })
  }
}
</script>